import React from 'react'
import I18n from 'translations/i18n'
import PropTypes from 'prop-types'
import { Typography } from '@jisr-hr/ds'
import { Button, Popper, Grid, Flex } from '@jisr-hr/design-system'

import { ReactComponent as Dots } from 'assets/images/dots-icon.svg'
import DSIcon from 'components/DSIcon'

import Styles from '../Request.module.css'

const Options = ({ list }) => (
  <Popper
    placement="top-start"
    className={Styles.optionsPopper}
    trigger={
      <Button
        size="small"
        icon={
          <Dots
            style={{
              transform: 'rotate(90deg)',
            }}
          />
        }
        variant="secondary"
        onClick={() => {}}
      />
    }
  >
    <Flex
      flexCol
      className={Styles.option}
    >
      {list.map((option) => (
        <Option
          key={option.title}
          title={I18n.t(option.title)}
          description={option.description}
          onClick={option.onClick}
          iconName={option.iconName}
        />
      ))}
    </Flex>
  </Popper>
)

Options.propTypes = {
  list: PropTypes.arrayOf({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    iconName: PropTypes.string,
  }),
}

const Option = ({ title, description, onClick, iconName }) => (
  <Grid
    container
    onClick={onClick}
  >
    <Grid
      item
      xs={12}
    >
      <Flex flexCol>
        <Flex
          itemsCenter
          style={{ gap: 4 }}
        >
          {iconName && <DSIcon name={iconName} />}
          <Typography
            text={title}
            style={{ color: 'var(--color-base-colors-black-500)' }}
            variant="subheading"
          />
        </Flex>
        {description && (
          <Typography
            text={description}
            style={{ color: 'var(--color-base-colors-grey-600)' }}
            variant="body-new/regular"
          />
        )}
      </Flex>
    </Grid>
  </Grid>
)

Option.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  iconName: PropTypes.string,
}

export default Options
